import { FloatingServiceMenu, Footer, Header, Page, PageTransition } from '@components/Page'
import { pickSeoProps } from '@components/Page/Page'
import { RichExperiencePagesContentBlock } from '@components/_rich-experience-page/ContentBlocks'
import { RichExperiencePageHero } from '@components/_rich-experience-page/Hero'
import { getDataCodenameValues } from '@lib/getDataCodenameValues'
import { SingleItemResponse } from '@lib/kontent'
import { RichExperiencePage as RichExperiencePageModel } from '@lib/kontent/models/RichExperiencePage'
import { FC, useState } from 'react'

type RichExperiencePageProps = SingleItemResponse<RichExperiencePageModel>

const RichExperiencePage: FC<RichExperiencePageProps> = ({ item, modular_content }) => {
  const [showOtherContent, setShowOtherContent] = useState(false)
  const keys = getDataCodenameValues(item.elements.content_blocks__blocks.value)
  const contentBlocks = keys.map((key) => ({
    type: modular_content[key].system.type,
    elements: modular_content[key].elements,
  }))

  return (
    <Page {...pickSeoProps(item.elements)}>
      <FloatingServiceMenu />
      <Header initialVariant="absolute" />
      <PageTransition>
        <RichExperiencePageHero
          title={item.elements.hero_title.value}
          description={item.elements.hero_description.value}
          mobileImage={item.elements.hero_mobile_image}
          desktopImage={item.elements.hero_desktop_image}
          handleImageLoaded={() => setShowOtherContent(true)}
        />
        <RichExperiencePagesContentBlock
          showContent={showOtherContent}
          contentBlocks={contentBlocks}
          modularContent={modular_content}
        />
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default RichExperiencePage
